


































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator';
import { ContentCategory, IScenario } from '../models';
import { CollectionNames, CollectionNamesArr } from '../services/meiosis';
import { translateCollName } from '../i18n';
import TableCard from './table-card.vue';

@Component({
  components: { TableCard },
})
export default class ConsistencyMatrices extends Vue {
  private tab = 0;
  private scenario: Partial<IScenario> = {};
  private rows: Array<CollectionNames> = [];
  private categories: { [key in ContentCategory]: Array<CollectionNames> } = {} as {
    [key in ContentCategory]: Array<CollectionNames>;
  };
  private categoryNames: ContentCategory[] = [];
  private selectedCategory: CollectionNames | null = null;
  private selectedCategory2: CollectionNames | null = null;

  constructor() {
    super();
  }

  @Watch('scenario.inconsistencies')
  private inconsistenciesChanged() {
    this.$store.actions['scenarios'].save(this.scenario);
  }

  private tabChanged(newTab: number) {
    console.log(newTab);
    this.selectedCategory = Object.values(this.categories)[newTab][0];
  }

  private getCategoryRows(cat: ContentCategory): CollectionNames[] {
    return this.rows.filter(r => this.categories[cat].includes(r));
  }

  private getCategoryRowsMap(cat: ContentCategory): any[] {
    return this.getCategoryRows(cat).map(c => ({ text: translateCollName(c), value: c }));
  }

  private async init() {
    this.$store.states.map(s => {
      this.scenario = s.scenarios.current || this.scenario;
      if (this.scenario && !this.scenario.inconsistencies) this.scenario.inconsistencies = [];
      this.rows.length = 0;
      CollectionNamesArr.forEach(n => {
        this.rows.push(n);
      });
      this.categories =
        this.scenario && this.scenario.categories
          ? this.scenario.categories
          : ({} as { [key in ContentCategory]: Array<CollectionNames> });
      this.selectedCategory = this.selectedCategory ? this.selectedCategory : this.rows.length > 0 ? this.rows[0] : null;
      this.categoryNames = Object.keys(this.categories || []) as ContentCategory[];
    });
  }

  async mounted(): Promise<void> {
    console.log(`ConsistencyMatrices mounted`);
    await this.init();
  }
}
